document.addEventListener('DOMContentLoaded', () => {
  /* =========================
   * header 表示制御
   * ========================= */
  const header = document.querySelector('header');
  const menuWrapper = document.querySelector('.mas-menu-wrapper');
  // const kv = document.querySelector('.mas-kv_wrapper');

  let ticking = false;
  let lastScrollY = window.scrollY;

  // isfixed が付いた瞬間の scrollY
  let fixedStartY = null;

  function isSP() {
    return window.matchMedia('(max-width: 719px)').matches;
  }

  function onScroll() {
    const scrollY = window.scrollY;
    const threshold = window.innerHeight;

    /* =========================
     * header / isfixed 制御
     * ========================= */
    if (header && menuWrapper) {
      if (scrollY >= threshold) {
        // isfixed が「初めて」付いた瞬間を記録
        if (!menuWrapper.classList.contains('isfixed')) {
          fixedStartY = scrollY;
        }

        header.classList.add('isvisible');
        menuWrapper.classList.add('isfixed');
      } else {
        header.classList.remove('isvisible');
        menuWrapper.classList.remove('isfixed');
        menuWrapper.classList.remove('is-down');
        fixedStartY = null; // リセット
      }

      /* =========================
       * SP + isfixed 時の上下判定
       * ========================= */
      if (
        menuWrapper.classList.contains('isfixed') &&
        isSP() &&
        fixedStartY !== null
      ) {
        // const passed = scrollY - fixedStartY;

        // 400px 進むまでは is-down をつけない
        // if (passed >= 400) {
        //   const delta = scrollY - lastScrollY;

        //   // 微振動防止
        //   if (Math.abs(delta) > 2) {
        //     if (delta > 0) {
        //       // 下スクロール
        //       menuWrapper.classList.add('is-down');
        //     } else {
        //       // 上スクロール
        //       menuWrapper.classList.remove('is-down');
        //     }
        //   }
        // } else {
        //   // ガード中は必ず解除
        //   menuWrapper.classList.remove('is-down');
        // }
        const delta = scrollY - lastScrollY;
        if (Math.abs(delta) > 2) {
          if (isAnchorScrolling) {
            menuWrapper.classList.add('is-down');
          } else {
            if (delta > 0) {
              // 下スクロール
              menuWrapper.classList.add('is-down');
            } else {
              // 上スクロール
              menuWrapper.classList.remove('is-down');
            }
          }
        }
      } else {
        menuWrapper.classList.remove('is-down');
      }
    }

    /* =========================
     * KV parallax
     * ========================= */
    // if (kv) {
    //   const y = scrollY * 0.1;
    //   kv.style.transform = `translate3d(0, -${y}px, 0)`;
    // }

    lastScrollY = scrollY;
    ticking = false;
  }

  // 初期反映
  onScroll();

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );

  // resize 時の保険
  window.addEventListener('resize', () => {
    if (!menuWrapper) return;
    if (!isSP()) menuWrapper.classList.remove('is-down');
  });



  // 初期位置を反映
  onScroll();

  /* =========================
   * Swiper
   * ========================= */
  const swiper = new Swiper('.js-mb-art-salon-top-slider', {
  loop: true,

  effect: 'fade',

  fadeEffect: {
    crossFade: true,
  },

  speed: 1000,

  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

  on: {
    init(swiper) {
      startImageMove(swiper);
    },

    slideChangeTransitionStart(swiper) {
      startImageMove(swiper);
    },

    slideChangeTransitionEnd(swiper) {
      resetOtherImages(swiper);
    }
  }
});


function startImageMove(swiper) {
  const slide = swiper.slides[swiper.activeIndex];
  const img = slide?.querySelector('.mb-art-salon__top-image img');

  if (!img) return;

  // スタート地点
  img.style.transition = 'none';
  img.style.transform = 'translateX(-50px)';

  // 強制的にスタイルを確定
  void img.offsetWidth;

  // 次フレームから動かす
  requestAnimationFrame(() => {
    img.style.transition = 'transform 9s linear';
    img.style.transform = 'translateX(0)';
  });
}


function resetOtherImages(swiper) {
  swiper.slides.forEach((slide, index) => {
    if (index === swiper.activeIndex) return;

    const img = slide.querySelector('.mb-art-salon__top-image img');
    if (!img) return;

    img.style.transition = 'none';
    img.style.transform = 'translateX(-50px)';
  });
}


  /*----------------------------------
   * アンカースクロール処理
   *---------------------------------*/
  const anchors = document.querySelectorAll('.js-anchor');
  let isAnchorScrolling = false;
  let anchorTimer = null;

  anchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      isAnchorScrolling = true;
      clearTimeout(anchorTimer);
      anchorTimer = setTimeout(() => {
        isAnchorScrolling = false;
      }, 1500);
      const targetID = this.getAttribute('href');
      menuWrapper.classList.add('is-down');
      if (targetID === '#top') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
          speed: 2000
        });
        return;
      } else {
        return;
      }
    });
  });

});

// menu current indicator (scroll position based)
// 要件:
// - スクロールに応じて黒丸(current)が移動
// - 現在地判定: セクション上端が「ウィンドウトップ基準ライン」より上にある（rect.top <= line）
// - PC(min-width:720px)はスクロール補正 99px（ただし #about のクリック遷移だけ補正なし）
// - #top は 0 へ
// - 戻り(上方向)でガタつかないように「遅延確定 + ヒステリシス」
// - 上向きスクロールでも固まらない（scrollDir 定義/更新込み）

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('.mas-menu-items');
  const items = Array.from(document.querySelectorAll('.mas-menu-item'));
  if (!menu || items.length === 0) return;

  // indicator
  const indicator = document.createElement('span');
  indicator.className = 'mas-menu-indicator';
  menu.prepend(indicator);

  // ===== チューニング（ここだけ触ればOK）=====
  const ENTER_BUFFER = 18;   // 下へ進む時の余裕（大きいほど切替が遅くなる）
  const LEAVE_BUFFER = 40;   // 上へ戻る時の余裕（大きいほど戻りにくい）
  const COMMIT_DELAY = 160;  // 確定を遅らせるms（120〜220くらい）

  // ===== スクロール補正 =====
  // クリックでスクロールするときの補正（#aboutだけ0）
  function getClickOffset(href = '') {
    if (href === '#about') return 0;
    return window.matchMedia('(min-width: 720px)').matches ? 99 : 76;
  }
  // 現在地判定（スクロール追従）の基準ライン（共通）
  function getJudgeBaseLine() {
    return window.matchMedia('(min-width: 720px)').matches ? 99 : 76;
  }

  // #top link
  const topLink = items.find(a => (a.getAttribute('href') || '') === '#top') || null;

  // pairs（#top は除外）
  const pairs = items
    .map((a) => {
      const href = a.getAttribute('href') || '';
      if (href === '#top') return null;

      const id = href.replace('#', '');
      const section = id ? document.getElementById(id) : null;
      return section ? { a, section, href } : null;
    })
    .filter(Boolean);

  if (pairs.length === 0) {
    if (topLink) {
      items.forEach(i => i.classList.remove('current'));
      topLink.classList.add('current');
    }
    return;
  }

  let activeLink = null;
  let activeIndex = -1; // -1 は #top、0.. は pairs

  // クリック遷移中ロック（到達まで切替を止める）
  let isLocked = false;
  let lockTarget = null;
  let lockHref = null;

  // 遅延確定用
  let pendingIndex = null;
  let commitTimer = null;

  // スクロール方向検出（上向き固まり対策）
  let lastScrollY = window.scrollY;
  let scrollDir = 'down'; // 'up' | 'down'

  function applyIndicatorPosition(linkEl) {
    const menuRect = menu.getBoundingClientRect();
    const linkRect = linkEl.getBoundingClientRect();
    const y = (linkRect.top - menuRect.top) + (linkRect.height / 2) - 4;
    indicator.style.transform = `translate3d(0, ${y}px, 0)`;
  }

  function setActive(linkEl, force = false) {
    if (!linkEl) return;
    if (!force && linkEl === activeLink) return;

    if (linkEl !== activeLink) {
      items.forEach(item => item.classList.remove('current'));
      linkEl.classList.add('current');
      activeLink = linkEl;
    }
    applyIndicatorPosition(linkEl);
  }

  function setActiveByIndex(idx, force = false) {
    // idx: -1 = #top, 0..pairs.length-1 = pairs
    if (idx === -1) {
      if (topLink) {
        activeIndex = -1;
        setActive(topLink, force);
      }
      return;
    }
    const p = pairs[idx];
    if (!p) return;
    activeIndex = idx;
    setActive(p.a, force);
  }

  // ===== クリック時スクロール（PC -99px / #aboutは0）=====
  function scrollToTarget(targetEl, href) {
    const offset = getClickOffset(href);
    const top = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  // ===== 候補Indexを決める（判定：topが基準ラインより上）=====
  function getCandidateIndex() {
    // 上端付近なら #top を優先
    if (topLink && window.scrollY <= 2) return -1;

    const baseLine = getJudgeBaseLine();         // 0 or 183
    const enterLine = baseLine + ENTER_BUFFER;   // 下方向の切替ライン

    let current = null;
    for (let i = 0; i < pairs.length; i++) {
      const top = pairs[i].section.getBoundingClientRect().top;
      if (top <= enterLine) current = i;
    }
    return current === null ? -1 : current;
  }

  // ===== ヒステリシス（上方向の戻りを遅らせて“戻り”を防ぐ）=====
  function applyHysteresis(candidate) {
    // #top はそのまま
    if (activeIndex === -1) return candidate;

    // 上向きで「前のセクションに戻る」場合だけ厳しくする
    if (scrollDir === 'up' && candidate < activeIndex) {
      const baseLine = getJudgeBaseLine();
      const leaveLine = baseLine + LEAVE_BUFFER; // ★重要：+（戻り判定ライン）

      const activeTop = pairs[activeIndex].section.getBoundingClientRect().top;

      // activeTop がまだ leaveLine より上(小さい)なら戻さない
      // = もっと上に戻って activeTop が leaveLine を超えるまで待つ
      if (activeTop < leaveLine) {
        return activeIndex;
      }
    }

    return candidate;
  }

  // ===== 遅延確定（少し落ち着いてから黒丸を動かす）=====
  function scheduleCommit(nextIndex) {
    if (nextIndex === activeIndex) {
      pendingIndex = null;
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = null;
      return;
    }

    // 候補が変わったらタイマーをリセット
    if (pendingIndex !== nextIndex) {
      pendingIndex = nextIndex;
      if (commitTimer) clearTimeout(commitTimer);

      commitTimer = setTimeout(() => {
        setActiveByIndex(pendingIndex, true);
        pendingIndex = null;
        commitTimer = null;
      }, COMMIT_DELAY);
    }
  }

  // ===== スクロールで更新 =====
  function updateByScroll() {
    // クリック遷移中は目的地到達まで止める（ガタつき防止）
    if (isLocked && lockTarget) {
      const offset = getClickOffset(lockHref || '');
      const destTop = lockTarget.getBoundingClientRect().top + window.pageYOffset - offset;

      if (Math.abs(window.pageYOffset - destTop) > 6) return; // 到達許容
      isLocked = false;
      lockTarget = null;
      lockHref = null;
    }

    const candidate = getCandidateIndex();
    const filtered = applyHysteresis(candidate);
    scheduleCommit(filtered);
  }

  // 初期表示
  if (topLink && window.scrollY <= 2) {
    setActiveByIndex(-1, true);
  } else {
    setActiveByIndex(0, true);
  }
  updateByScroll();

  // scroll監視（rAFで軽量）＋方向更新
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      const y = window.scrollY;
      scrollDir = (y < lastScrollY) ? 'up' : 'down';
      lastScrollY = y;

      updateByScroll();
      ticking = false;
    });
  }, { passive: true });

  // リサイズ補正
  let rafId = null;
  function requestRecalc() {
    if (!activeLink) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      setActive(activeLink, true);
      updateByScroll();
      rafId = null;
    });
  }
  window.addEventListener('resize', requestRecalc);
  window.addEventListener('orientationchange', requestRecalc);

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(requestRecalc);
    ro.observe(menu);
    items.forEach(el => ro.observe(el));
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(requestRecalc).catch(() => {});
  }

  // クリック
  items.forEach((a) => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href') || '';
      e.preventDefault();

      // クリック時は即反映
      setActive(a, true);

      // pending/タイマーをクリア（遅延確定が割り込まないように）
      pendingIndex = null;
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = null;

      // #top
      if (href === '#top') {
        activeIndex = -1;
        isLocked = true;
        lockTarget = null;
        lockHref = href;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      const id = href.replace('#', '');
      const target = id ? document.getElementById(id) : null;
      if (!target) return;

      // ロック
      isLocked = true;
      lockTarget = target;
      lockHref = href;

      // スクロール（#about は補正なし）
      scrollToTarget(target, href);

      // クリック先indexを即時反映（戻り防止に効く）
      const idx = pairs.findIndex(p => p.section === target);
      if (idx >= 0) activeIndex = idx;
    });
  });
});






document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.mas-inprogress_carousel');
  const wrapper = document.querySelector('.mas-inprogress_swiper .swiper-wrapper_');
  if (!root || !wrapper) return;

  const PX_PER_SEC = 40; // ←速度（px/秒）
  let x = 0;
  let last = performance.now();
  let rafId = null;
  let paused = false;

  // 元の枚数（この分を「1セット」として巻き戻す）
  const originalCount = wrapper.children.length;

  // 画像のロード待ち
  const imgs = Array.from(wrapper.querySelectorAll('img'));
  const waitImages = Promise.all(
    imgs.map(img => img.complete ? Promise.resolve() : new Promise(res => {
      img.addEventListener('load', res, { once: true });
      img.addEventListener('error', res, { once: true });
    }))
  );

  function sumWidthOfFirstN(n) {
    let w = 0;

    // gap を取得（flex gap）
    const st = getComputedStyle(wrapper);
    const gap = parseFloat(st.columnGap || st.gap) || 0;

    for (let i = 0; i < n; i++) {
      const el = wrapper.children[i];
      if (!el) break;
      w += el.getBoundingClientRect().width;
      if (i < n - 1) w += gap; // ← gap分を加算
    }
    return w;
  }

  function ensureCopies() {
    const viewportW = root.getBoundingClientRect().width;

    // まず 1セット幅を測る（0ならレイアウト未確定）
    const base = sumWidthOfFirstN(originalCount);
    if (!base) return 0;

    while (wrapper.scrollWidth < viewportW * 4) {
      for (let i = 0; i < originalCount; i++) {
        wrapper.appendChild(wrapper.children[i].cloneNode(true));
      }
    }
    return base;
  }

  let baseWidth = 0;

  function recalc() {
    // レイアウトが変わるたびに再計測（SPで必須）
    baseWidth = ensureCopies();
    if (!baseWidth) return;

    // xを範囲内に正規化
    x = x % baseWidth;
    wrapper.style.transform = `translate3d(${x}px,0,0)`;
  }

  function tick(now) {
    if (!paused && baseWidth) {
      const dt = (now - last) / 1000;
      x -= PX_PER_SEC * dt;

      // 1セット分流れたら巻き戻す（継ぎ目なし）
      if (x <= -baseWidth) x += baseWidth;

      wrapper.style.transform = `translate3d(${x}px,0,0)`;
    }
    last = now;
    rafId = requestAnimationFrame(tick);
  }

  waitImages.then(() => {
    recalc();

    // SPでの幅変化に追従（回転/アドレスバー/画像の最終サイズなど）
    const ro = new ResizeObserver(() => recalc());
    ro.observe(root);

    rafId = requestAnimationFrame(tick);
  });

  // 任意：ホバー/タップ中停止
  // root.addEventListener('mouseenter', () => paused = true);
  // root.addEventListener('mouseleave', () => paused = false);

  // root.addEventListener('touchstart', () => paused = true, { passive: true });
  // root.addEventListener('touchend', () => paused = false, { passive: true });
});


(function () {

  const initMbArtSalonArticleSlider = () => {

    const sliders = document.querySelectorAll(
      '.js-mb-art-salon-article-slider'
    );

    if (!sliders.length) return;


    sliders.forEach((slider) => {

      if (slider.dataset.initialized === 'true') return;


      const track = slider.querySelector(
        '.js-mb-art-salon-article-slider-track'
      );

      const root = slider.closest(
        '.mb-art-salon__article-slider-wrapper'
      );

      if (!track || !root) return;


      slider.dataset.initialized = 'true';


      /* ========================================
         元画像を複製
         無限ループ用
      ======================================== */

      const originalItems = Array.from(track.children);

      if (!originalItems.length) return;


      originalItems.forEach((item) => {

        const clone = item.cloneNode(true);

        clone.setAttribute(
          'aria-hidden',
          'true'
        );

        track.appendChild(clone);

      });


      /* ========================================
         基本設定
      ======================================== */

      let position = 0;

      // px / frame
      const speed = 0.5;

      let isDragging = false;

      let dragStartX = 0;

      let dragStartPosition = 0;

      let resumeTimer = null;

      /* ========================================
        DRAG CURSOR
      ======================================== */

      const cursor = document.getElementById('customCursor');

      const isDesktop = () => {
        return window.matchMedia('(min-width: 750px)').matches;
      };


      /* スライダーに入った */

      root.addEventListener('mouseenter', () => {

        if (!isDesktop() || !cursor) return;

        cursor.classList.add('is-drag-cursor');

      });


      /* スライダーから出た */

      root.addEventListener('mouseleave', () => {

        if (!cursor) return;

        cursor.classList.remove('is-drag-cursor');
        cursor.classList.remove('is-dragging');

      });


      /* 通常ホバー中のカーソル追従 */

      root.addEventListener('pointermove', (e) => {

        if (!isDesktop() || !cursor) return;

        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;

      });


      /* ========================================
         POSITION 正規化
      ======================================== */

      const normalizePosition = () => {

        const resetPoint = track.scrollWidth / 2;

        if (!resetPoint) return;


        while (position >= resetPoint) {
          position -= resetPoint;
        }

        while (position < 0) {
          position += resetPoint;
        }

      };


      const render = () => {

        normalizePosition();

        track.style.transform =
          `translate3d(${-position}px, 0, 0)`;

      };


      /* ========================================
         AUTO SCROLL
      ======================================== */

      const animate = () => {

        if (!isDragging) {

          position += speed;

          render();

        }

        requestAnimationFrame(animate);

      };


      requestAnimationFrame(animate);


      /* ========================================
         DRAG START
      ======================================== */

      slider.addEventListener('pointerdown', (e) => {

        // 左クリック以外は無視
        if (
          e.pointerType === 'mouse' &&
          e.button !== 0
        ) {
          return;
        }


        clearTimeout(resumeTimer);


        isDragging = true;

        dragStartX = e.clientX;

        dragStartPosition = position;


        slider.setPointerCapture?.(e.pointerId);


        root.classList.add('is-dragging');

        if (cursor) {
          cursor.classList.add('is-dragging');
        }


        e.preventDefault();

      });


      /* ========================================
         DRAG MOVE
      ======================================== */

      slider.addEventListener('pointermove', (e) => {

        /* ========================================
          CUSTOM CURSOR
        ======================================== */

        if (
          isDesktop() &&
          cursor
        ) {

          cursor.style.left = `${e.clientX}px`;
          cursor.style.top = `${e.clientY}px`;

        }


        /* ========================================
          DRAG
        ======================================== */

        if (!isDragging) return;

        const diff =
          e.clientX - dragStartX;

        position =
          dragStartPosition - diff;

        render();

      });


      /* ========================================
         DRAG END
      ======================================== */

      const endDrag = (e) => {

        if (!isDragging) return;


        isDragging = false;


        root.classList.remove(
          'is-dragging'
        );

        if (cursor) {
          cursor.classList.remove('is-dragging');
        }

        if (
          e.pointerId !== undefined &&
          slider.hasPointerCapture?.(e.pointerId)
        ) {

          slider.releasePointerCapture(
            e.pointerId
          );

        }

      };


      slider.addEventListener(
        'pointerup',
        endDrag
      );


      slider.addEventListener(
        'pointercancel',
        endDrag
      );


      /* ========================================
         画像ドラッグ禁止
      ======================================== */

      slider.addEventListener(
        'dragstart',
        (e) => {
          e.preventDefault();
        }
      );

    });

  };


  document.addEventListener(
    'DOMContentLoaded',
    initMbArtSalonArticleSlider
  );


  document.addEventListener(
    'shopify:section:load',
    initMbArtSalonArticleSlider
  );

})();